import { SCHEDULE_ENDTYPE } from '@nile/client_management/src/Containers/ClientDetails/ClientContract/constants';
import { plaintextValidator } from '../fields';

const config = { mandatory: true };

// const prefix = 'scheduleDefinition.data.';
const prefix = '';

const getMonthType = (type) => {
  switch (type) {
    case 'DAY_OF_MONTH':
      return { [`${prefix}dayOfMonth`]: plaintextValidator(config) };
    case 'WEEK_OF_MONTH':
      return {
        [`${prefix}week`]: plaintextValidator(config),
        [`${prefix}dayOfWeek`]: plaintextValidator(config)
      };
    default:
      return {};
  }
};

const getScheduleObject = (type, monthType, data) => {
  let baseCondition = {};
  if (data.hasOwnProperty('startDateAndTime')) {
    baseCondition = {
      [`${prefix}startDateAndTime`]: plaintextValidator(config)
    };
  }
  if (data.hasOwnProperty('time')) {
    baseCondition = {
      [`${prefix}time`]: plaintextValidator(config)
    };
  }
  switch (type) {
    case 'WEEKLY':
      return {
        [`${prefix}dayOfWeek`]: plaintextValidator(config),
        ...baseCondition
      };
    case 'MONTHLY':
      return {
        [`${prefix}type`]: plaintextValidator(config),
        // week: plaintextValidator(config),
        // dayOfWeek: plaintextValidator(config),
        // dayOfMonth: plaintextValidator(config), //only if type is DAY_OF_MONTH and not WEEK_OF_MONTH
        ...getMonthType(monthType),
        ...baseCondition
      };
    case 'HOURLY':
    case 'DAILY':
    default:
      return baseCondition;
  }
};

const getScheduleEndObject = (endType, data) => {
  if (!data?.endType) return;
  const baseCondition = {
    [`${prefix}endType`]: plaintextValidator(config)
  };
  switch (endType) {
    case SCHEDULE_ENDTYPE.AFTERNRUNS:
      return {
        [`${prefix}repeatCount`]: plaintextValidator(config),
        ...baseCondition
      };
    case SCHEDULE_ENDTYPE.AFTERDATETIME:
      return {
        [`${prefix}endDateAndTime`]: plaintextValidator(config),
        ...baseCondition
      };
    default:
      return baseCondition;
  }
};

const getObject = (type, monthType = '', endType, data) => {
  const endObejct = getScheduleEndObject(endType, data);
  const startObject = getScheduleObject(type, monthType, data);
  return { ...endObejct, ...startObject };
};

export default (type, monthType = '', endType, data) => ({
  ...getObject(type, monthType, endType, data)
});
